import React from 'react'
import {connect} from "react-redux"

class UserFullName extends React.Component{
  render(){
    return this.props.user.userName;
  }
}

const state=(state)=>({
  user: state.auth
})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(UserFullName);


// WEBPACK FOOTER //
// ./src/views/Users/UserFullName.jsx